import { PublicLinkType, PublicLinkDisplayModeModule_fromInt, PublicLinkSecurityModeModule_fromInt, PublicLinkTypeModule_fromInt } from "../Shared/Types.js";
import { ta, t } from "../Lang.js";
import { Sharing_noLinks, Sharing_loading, Sharing_usingArrangement, Sharing_shareFloorPlan, Sharing_createFindSeat, Sharing_goToArrangements, Sharing_needArrangement, Sharing_description, Sharing_title, Sharing_delete, Sharing_copyEmbedCode, Sharing_embedDescription, Sharing_embedCode, Sharing_expiresLabel, Sharing_displayLabel, Sharing_securityLabel, Sharing_copy, Sharing_lookups, Sharing_findYourSeat, Overview_rsvp, Sharing_seatingChart, Sharing_floorPlan, Sharing_inactive, Sharing_active, Sharing_tableOnly, Sharing_fullChart, Sharing_tableAndNeighbors, Sharing_tableAndDiagram, Sharing_nameLookup, Sharing_openView, Sharing_pinProtected, Sharing_nameAndKeyword } from "../Shared/Tr.js";
import { createElement } from "react";
import { int32ToString, createObj } from "../fable_modules/fable-library-js.4.28.0/Util.js";
import { reactApi } from "../fable_modules/Feliz.2.9.0/Interop.fs.js";
import { map, tryHead, tryFind, isEmpty, singleton as singleton_1, ofArray } from "../fable_modules/fable-library-js.4.28.0/List.js";
import { singleton, append, delay, toList } from "../fable_modules/fable-library-js.4.28.0/Seq.js";
import { defaultOf } from "../fable_modules/fable-library-js.4.28.0/Util.js";
import { Msg } from "../App/Messages.js";
import { orElse } from "../fable_modules/fable-library-js.4.28.0/Option.js";

function linkUrl(token, linkType) {
    const origin = window.location.origin;
    const matchValue = PublicLinkTypeModule_fromInt(linkType);
    switch (matchValue.tag) {
        case 2:
            return `${origin}/plan/${token}`;
        case 0:
            return `${origin}/s/${token}`;
        case 3:
            return `${origin}/s/${token}`;
        default:
            return `${origin}/plan/${token}`;
    }
}

function securityModeLabel(mode) {
    const matchValue = PublicLinkSecurityModeModule_fromInt(mode);
    switch (matchValue.tag) {
        case 1:
            return t(Sharing_nameAndKeyword);
        case 2:
            return t(Sharing_pinProtected);
        case 3:
            return t(Sharing_openView);
        default:
            return t(Sharing_nameLookup);
    }
}

function displayModeLabel(mode) {
    const matchValue = PublicLinkDisplayModeModule_fromInt(mode);
    switch (matchValue.tag) {
        case 1:
            return t(Sharing_tableAndDiagram);
        case 2:
            return t(Sharing_tableAndNeighbors);
        case 3:
            return t(Sharing_fullChart);
        default:
            return t(Sharing_tableOnly);
    }
}

function embedSnippet(token) {
    return `<div data-whositswhere="${token}" data-mode="find-seat" data-theme="elegant"></div>
<script src="${window.location.origin}/widget.js" async></script>`;
}

function linkCard(link, dispatch) {
    let elems_6, elems, matchValue, tupledArg, elems_1, elems_2, elems_4, elems_3, elems_5;
    const url = linkUrl(link.Token, link.LinkType);
    const isActive = link.IsActive;
    return createElement("div", createObj(ofArray([["className", "sharing-link-card card"], (elems_6 = [createElement("div", createObj(ofArray([["className", "sharing-link-header"], (elems = [createElement("span", {
        className: isActive ? "badge badge-success" : "badge badge-secondary",
        children: isActive ? t(Sharing_active) : t(Sharing_inactive),
    }), createElement("span", {
        className: "sharing-link-type",
        children: (matchValue = PublicLinkTypeModule_fromInt(link.LinkType), (matchValue.tag === 1) ? t(Sharing_floorPlan) : ((matchValue.tag === 2) ? t(Sharing_seatingChart) : ((matchValue.tag === 3) ? t(Overview_rsvp) : t(Sharing_findYourSeat)))),
    }), createElement("span", {
        className: "sharing-link-lookups",
        children: (tupledArg = Sharing_lookups(int32ToString(link.LookupCount)), ta(tupledArg[0], tupledArg[1])),
    })], ["children", reactApi.Children.toArray(Array.from(elems))])]))), createElement("div", createObj(ofArray([["className", "sharing-link-url"], (elems_1 = [createElement("input", {
        type: "text",
        readOnly: true,
        value: url,
        className: "sharing-url-input",
    }), createElement("button", {
        className: "btn btn-sm btn-outline",
        children: t(Sharing_copy),
        onClick: (_arg) => {
            navigator.clipboard.writeText(url);
        },
    })], ["children", reactApi.Children.toArray(Array.from(elems_1))])]))), createElement("div", createObj(ofArray([["className", "sharing-link-meta"], (elems_2 = toList(delay(() => append(singleton(createElement("span", {
        children: t(Sharing_securityLabel) + securityModeLabel(link.SecurityMode),
    })), delay(() => append(singleton(createElement("span", {
        children: t(Sharing_displayLabel) + displayModeLabel(link.DisplayMode),
    })), delay(() => {
        const matchValue_1 = link.ExpiresAt;
        if (matchValue_1 == null) {
            return singleton(defaultOf());
        }
        else {
            const exp = matchValue_1;
            return singleton(createElement("span", {
                children: t(Sharing_expiresLabel) + exp,
            }));
        }
    })))))), ["children", reactApi.Children.toArray(Array.from(elems_2))])]))), createElement("div", createObj(ofArray([["className", "sharing-embed-section"], (elems_4 = [createElement("details", createObj(singleton_1((elems_3 = [createElement("summary", {
        className: "sharing-embed-toggle",
        children: t(Sharing_embedCode),
    }), createElement("p", {
        className: "sharing-embed-description",
        children: t(Sharing_embedDescription),
    }), createElement("pre", {
        className: "sharing-embed-code",
        children: embedSnippet(link.Token),
    }), createElement("button", {
        className: "btn btn-sm btn-outline",
        children: t(Sharing_copyEmbedCode),
        onClick: (_arg_1) => {
            navigator.clipboard.writeText(embedSnippet(link.Token));
        },
    })], ["children", reactApi.Children.toArray(Array.from(elems_3))]))))], ["children", reactApi.Children.toArray(Array.from(elems_4))])]))), createElement("div", createObj(ofArray([["className", "sharing-link-actions"], (elems_5 = [createElement("button", {
        className: "btn btn-sm btn-danger",
        children: t(Sharing_delete),
        onClick: (_arg_2) => {
            dispatch(new Msg(266, [link.Id]));
        },
    })], ["children", reactApi.Children.toArray(Array.from(elems_5))])])))], ["children", reactApi.Children.toArray(Array.from(elems_6))])])));
}

export function view(state, dispatch) {
    let elems_3;
    let eventId;
    const matchValue = state.Event;
    eventId = ((matchValue == null) ? "" : matchValue.Id);
    const arrangements = state.Arrangements;
    return createElement("div", createObj(ofArray([["className", "sharing-container"], (elems_3 = toList(delay(() => append(singleton(createElement("h3", {
        children: t(Sharing_title),
    })), delay(() => append(singleton(createElement("p", {
        className: "sharing-description",
        children: t(Sharing_description),
    })), delay(() => {
        let elems, matchValue_2, arr, elems_1, tupledArg;
        return append(isEmpty(arrangements) ? singleton(createElement("div", createObj(ofArray([["className", "sharing-no-arrangements"], (elems = [createElement("p", {
            children: t(Sharing_needArrangement),
        }), createElement("p", {
            children: t(Sharing_goToArrangements),
        })], ["children", reactApi.Children.toArray(Array.from(elems))])])))) : ((matchValue_2 = orElse(tryFind((a) => a.IsSelected, arrangements), tryHead(arrangements)), (matchValue_2 != null) ? ((arr = matchValue_2, singleton(createElement("div", createObj(ofArray([["className", "sharing-create-section"], (elems_1 = [createElement("button", {
            className: "btn btn-primary",
            children: t(Sharing_createFindSeat),
            onClick: (_arg) => {
                dispatch(new Msg(264, [eventId, arr.Id, new PublicLinkType(0, [])]));
            },
        }), createElement("button", {
            className: "btn btn-secondary",
            children: t(Sharing_shareFloorPlan),
            onClick: (_arg_1) => {
                dispatch(new Msg(264, [eventId, arr.Id, new PublicLinkType(1, [])]));
            },
        }), createElement("span", {
            className: "sharing-arrangement-info",
            children: (tupledArg = Sharing_usingArrangement(int32ToString(~~arr.Score)), ta(tupledArg[0], tupledArg[1])),
        })], ["children", reactApi.Children.toArray(Array.from(elems_1))])])))))) : singleton(defaultOf()))), delay(() => {
            let elems_2;
            if (state.PublicLinksLoading) {
                return singleton(createElement("div", {
                    className: "loading",
                    children: t(Sharing_loading),
                }));
            }
            else {
                const matchValue_3 = state.PublicLinks;
                return isEmpty(matchValue_3) ? (!isEmpty(arrangements) ? singleton(createElement("p", {
                    className: "sharing-no-links",
                    children: t(Sharing_noLinks),
                })) : singleton(defaultOf())) : singleton(createElement("div", createObj(ofArray([["className", "sharing-links-list"], (elems_2 = map((link) => linkCard(link, dispatch), matchValue_3), ["children", reactApi.Children.toArray(Array.from(elems_2))])]))));
            }
        }));
    })))))), ["children", reactApi.Children.toArray(Array.from(elems_3))])])));
}

